import { QueryFunction, useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import { ChipProps as MuiChipProps } from '@mui/material/Chip/Chip';
import { FilterChip } from './FilterChip';

type FilterAsyncChipProps = {
  onCancel: () => void;
  labelPrefix: string;
  fieldName: string;
  queryFn: QueryFunction;
  queryKey: string[];
  queryEnabled: boolean;
  variant?: MuiChipProps['variant'];
};

export const FilterAsyncChip = ({
  onCancel,
  labelPrefix,
  fieldName,
  queryFn,
  queryKey,
  queryEnabled,
  variant = 'filled',
}: FilterAsyncChipProps) => {
  const { data, isLoading } = useQuery({
    queryKey: [...queryKey],
    queryFn: queryFn,
    enabled: queryEnabled,
  });

  useEffect(() => {
    // @ts-expect-error -- status might not exist on the returned data out of the query
    if (data?.status === 404) {
      onCancel();
    }
  }, [data]);

  return (
    <>
      {
        // @ts-expect-error -- status might not exist on the returned data out of the query
        data && (!data.status || data.status !== 404) ? (
          <FilterChip
            // @ts-expect-error -- `fieldName` might not exist on the returned data out of the query
            text={`${labelPrefix}: ${data?.[fieldName]}`}
            size="medium"
            variant={variant}
            onClose={onCancel}
            isLoading={isLoading}
          />
        ) : null
      }
    </>
  );
};
